import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../assets/logocip.png';
import { useCart } from '../context/CartContext';
import SideCartDrawer from './SideCartDrawer';

const yellow = '#f3e81c'; // Added



// Анимация рычания льва
const lionRoar = keyframes`
  0% { 
    transform: scale(1) rotate(0deg);
  }
  10% { 
    transform: scale(1.05) rotate(-1deg);
  }
  20% { 
    transform: scale(1.08) rotate(1deg);
  }
  30% { 
    transform: scale(1.06) rotate(-0.5deg);
  }
  40% { 
    transform: scale(1.1) rotate(0.8deg);
  }
  50% { 
    transform: scale(1.12) rotate(-1.2deg);
  }
  60% { 
    transform: scale(1.08) rotate(0.6deg);
  }
  70% { 
    transform: scale(1.05) rotate(-0.3deg);
  }
  80% { 
    transform: scale(1.03) rotate(0.2deg);
  }
  90% { 
    transform: scale(1.01) rotate(-0.1deg);
  }
  100% { 
    transform: scale(1) rotate(0deg);
  }
`;

const HeaderBar = styled.header`
  width: 100%;
  display: flex;
  align-items: stretch;
  padding: 0;
  height: 100px;
  box-sizing: border-box;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: ${({ backgroundYellow }) => backgroundYellow ? yellow : 'none'};
  
  @media (max-width: 1024px) and (min-width: 769px) {
    height: 85px;
    padding: 0 10px;
  }
  
  @media (max-width: 768px) {
    height: 70px;
    padding: 0 15px;
    justify-content: center;
  }
  @media (max-width: 600px) {
    height: 60px;
    padding: 0 12px;
  }
`;

const HeaderLeft = styled.div`
  background: ${({ backgroundYellow }) => backgroundYellow ? 'none' : yellow};
  display: flex;
  align-items: center;
  padding: 0 48px;
  height: 100%;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    padding: 0 35px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
    justify-content: center;
    width: 100%;
  }
  @media (max-width: 600px) {
    padding: 0 12px;
  }
`;

const HeaderRight = styled.div`
  flex: 1;
  background: transparent;
`;

const Logo = styled.img`
  height: 120px;
  width: auto;
  margin-right: 3rem;
  transition: all 0.3s ease;
  animation: ${lionRoar} 2s ease-in-out infinite;
  animation-delay: 3s;
  transform-origin: center;
  
  &:hover {
    animation: ${lionRoar} 0.8s ease-in-out infinite;
    filter: brightness(1.1);
  }
  
  @media (max-width: 1024px) and (min-width: 769px) {
    height: 90px;
    margin-right: 2.5rem;
  }
  
  @media (max-width: 768px) {
    height: 60px;
    margin-right: 1.5rem;
  }
  
  @media (max-width: 600px) {
    height: 44px;
    margin-right: 1rem;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 2.5rem;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    gap: 1.5rem;
  }
  @media (max-width: 600px) {
    gap: 1rem;
  }
`;

const NavItem = styled(Link)`
  color: #181818;
  text-decoration: none;
  font-size: 1.18rem;
  font-family: 'Cubano', 'Arial Black', Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.3rem 0.7rem;
  border-radius: 18px;
  position: relative;
  transition: none;
  box-shadow: none;
  /* hover эффекты убраны */
  /* &:hover {
    color: #FF6B00;
    background: rgba(255, 107, 0, 0.08);
    box-shadow: 0 2px 8px rgba(255, 107, 0, 0.10);
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 18%;
    right: 18%;
    bottom: 7px;
    height: 2.5px;
    background: #FF6B00;
    border-radius: 2px;
    opacity: 0;
    transform: scaleX(0);
    transition: all 0.25s cubic-bezier(.4,0,.2,1);
  }
  &:hover::after {
    opacity: 1;
    transform: scaleX(1);
  } */
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 1.1rem;
    padding: 0.28rem 0.6rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
  }
  @media (max-width: 600px) {
    font-size: 0.98rem;
    padding: 0.2rem 0.3rem;
  }
`;

export default function Header({ backgroundYellow }) {
  const { cart } = useCart();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <HeaderBar backgroundYellow={backgroundYellow}>
      <HeaderLeft backgroundYellow={backgroundYellow}>
        <Logo 
          src={logo} 
          alt="Leod'or Logo"
        />
        <Nav>
          <NavItem to="/">Home</NavItem>
          <NavItem to="/shop">Shop</NavItem>
          <NavItem to="/blog">Blog</NavItem>
          <NavItem to="/contact">Contact</NavItem>
        </Nav>
      </HeaderLeft>
      <HeaderRight />
      <SideCartDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </HeaderBar>
  );
}